import * as React from "react";
function SvgVkontakte(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <path
        fill="#fff"
        d="M23.26 15.88s2.9-4.08 3.18-5.42c.1-.48-.11-.75-.61-.75h-2.51a.91.91 0 00-1 .61 23.33 23.33 0 01-3 4.72c-.53.59-.81.77-1.09.77s-.35-.2-.35-.73v-4.67c0-.65-.07-.84-.61-.84h-4.03a.42.42 0 00-.34.1.43.43 0 00-.16.32c0 .61.94.75.94 2.42v3.43c0 .69 0 1-.36 1-.87 0-2.91-3-4.07-6.34-.23-.69-.48-.88-1.13-.88H5.63a.58.58 0 00-.63.6c0 .69.78 3.78 3.87 7.94 2.06 2.8 4.81 4.31 7.25 4.31 1.5 0 1.86-.24 1.86-.87v-2.16c0-.54.21-.77.52-.77s.92.08 2.38 1.46c1.69 1.61 1.8 2.28 2.75 2.28h2.81c.29 0 .56-.14.56-.61 0-.64-.82-1.77-2.06-3.11-.52-.69-1.37-1.43-1.63-1.78-.45-.38-.31-.61-.05-1.03z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgVkontakte);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
